import React from "react";

const CustomPageManager = ({ pages, onCreate, onEdit, onDelete, activeSlug, disabled = false }) => {
  return (
    <div className="border bg-bookish-white/70 border-bookish-purple/20 rounded-xl p-4 md:p-6 bg-bookish-purple/5 space-y-3">
      <h2 className="text-xl font-semibold">Custom Pages</h2>

      {!disabled && pages.length === 0 && (
        <p className="text-sm text-bookish-purpleAccent">No custom pages yet.</p>
      )}

      <div className="space-y-2">
        {pages.map((page) => (
          <div
            key={page.slug}
            className="flex flex-wrap gap-3 items-center justify-between border border-bookish-purple/15 rounded px-3 py-2 bg-white"
          >
            <div className="flex flex-wrap min-w-0 items-center gap-3">
              <span className={"break-words min-w-0 " + (activeSlug === page.slug ? "font-semibold" : "")}>
                {page.title}
              </span>

              <span
                className={`text-xs px-2 py-0.5 rounded-full border ${
                  page.published
                    ? "bg-green-50 text-green-700 border-green-200"
                    : "bg-amber-50 text-amber-700 border-amber-200"
                }`}
              >
                {page.published ? "Published" : "Draft"}
              </span>
            </div>

            <div className="flex items-center gap-3">
              <button disabled={disabled}
                onClick={() => onEdit(page.slug)}
                className="min-h-[44px] px-2 text-sm text-bookish-royal hover:underline"
              >
                Edit
              </button>

              <button disabled={disabled}
                onClick={() => onDelete(page.slug)}
                className="min-h-[44px] px-2 text-sm text-red-600 hover:underline"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      <button disabled={disabled}
        onClick={onCreate}
        className="px-4 py-2 rounded-md border border-bookish-purple/30 hover:bg-bookish-purple/10"
      >
        + Create New Custom Page
      </button>
    </div>
  );
};

export default CustomPageManager;